/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Restock-Warteliste: spiegelt die Anmeldung des Benachrichtigungsformulars an
  // /apps/restock/request. Das Kontaktformular laeuft unveraendert weiter, die
  // Antwort wird nicht ausgewertet.
  const RESTOCK_ENDPOINT = '/apps/restock/request';

  document.addEventListener(
    'submit',
    (event) => {
      try {
        const form = event.target.closest('[data-notification-form]');
        if (!form) return;

        const email = form.querySelector('input[type="email"]')?.value?.trim();
        // Die aktuell gewaehlte Variante steht im Warenkorb-Formular derselben Sektion, nicht in
        // der id des Benachrichtigungsformulars (die traegt die Variante vom Seitenaufruf) - und
        // nicht im ersten Warenkorb-Formular des Dokuments: der Warenkorb-Drawer rendert
        // "Zuletzt angesehen" mit eigenen /cart/add-Formularen vor dem Hauptinhalt.
        const variantId = form
          .closest('[data-section-id]')
          ?.querySelector('form[action*="/cart/add"] [name="id"]')
          ?.value?.trim();
        if (!email || !variantId) return;

        const payload = new URLSearchParams({
          email,
          variant_id: `gid://shopify/ProductVariant/${variantId}`,
        });

        const sent =
          typeof navigator.sendBeacon === 'function' &&
          navigator.sendBeacon(RESTOCK_ENDPOINT, payload);
        if (!sent) {
          fetch(RESTOCK_ENDPOINT, { method: 'POST', body: payload, keepalive: true }).catch(
            () => {},
          );
        }
      } catch (error) {
        // Nie den Absendevorgang des Themes stoeren.
      }
    },
    true,
  );

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
